/// <amd-module name="typeahead/core/SuggestServiceParamModifier" />

import {ConfigurableFeature} from "ConfigurableFeature";
import {IOverrideParams} from "typeahead/core/IOverrideParams";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";

export abstract class SuggestServiceParamModifier extends ConfigurableFeature {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IOverrideParams):
            ISuggestServiceQueryParams {
        if (this.precondition &&
            (this.shouldOverride(options) || ExecutionHelper.shouldExecute(context, this.configuration))) {
            this.modify(params, context, options);
        }
        return params;
    }
    public addFeatureFlag(params: ISuggestServiceQueryParams, feature: string) {
        params.features = params.features && params.features.length && params.features.push ?
            params.features || [] : [];
        if (params.features.indexOf(feature) < 0) {
            params.features.push(feature);
        }
    }
    public addRegionType(params: ISuggestServiceQueryParams, regionType: number) {
        /* tslint:disable-next-line: no-bitwise */
        params.mask |= regionType;
    }
    protected precondition(params: ISuggestServiceQueryParams, context: IContext, options: any): boolean {
        return typeof params !== "undefined";
    }
    protected abstract modify(params: ISuggestServiceQueryParams, context: IContext, options: any);
}
